export default "__VITE_ASSET__BUznbZW___"